import { memo } from "react";

import parse from 'html-react-parser';

import styles from "./styles.module.scss";

import RadioButton from "../../lms/RadioComponent";

const CourseQuestionCards = (props) => {
  const {
  questionsList,
  activeIndex,
  animate,
  handleQuestionAnswer,
  selectedAnswers,
} = props;

  const question = questionsList?.[activeIndex];
  const selectedAnswerId = selectedAnswers?.[question?.id];

  return (
    <>
      {questionsList?.slice(activeIndex, activeIndex + 1).map((question) => (
        <div
          key={question?.assQuestionId}
          className={`${styles["question-wrapper"]} ${
            animate ? styles["stack-animate"] : ""
          }`}
        >
          {/* <div className={styles["card-back"]}></div>
          <div className={styles["card-middle"]}></div> */}

          <div className={styles["question-card"]}>
            <div className={styles["question-header"]}>
              Question {activeIndex + 1}
            </div>

            <div className={styles["question-body"]}>
              <p className={styles["question-text"]}>
                {parse(question?.name || '')}
              </p>

              <div className={styles["options-grid"]}>
                {question?.questionOptions?.map((option) => (
                  <RadioButton
                    key={option?.optionId}
                    name={`question-${question?.id}`}
                    label={option?.optionName}
                    checked={selectedAnswerId === option?.optionId}
                    onChange={() =>
                      handleQuestionAnswer(question , option)
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default memo(CourseQuestionCards);
